<template>
    <div class="d-tool-bar t-line">
        <div class="i-sy" @click="$router.replace('/')">
            <p><i class="iconfont icon-41"></i></p>首页
        </div>
        <div class="i-sy">
            <p><i class="iconfont icon-63"></i></p>攻略
        </div>
        <div class="i-tg" @click="$emit('tuiguan')">我要推广</div>
        <div class="i-bk" @click="$router.push('/apply')">我要办卡</div>
    </div>
</template>
<script>
export default {
    props: ['type']
}
</script>

<style lang="less" scoped>
    .d-tool-bar {
        position: fixed;
        z-index: 10;
        background: #fff;
        bottom: 0;
        width: 100%;
        left: 0;
        height: 50px;
        display: flex;
        text-align: center;
        .iconfont {
            font-size: 26px;
        }
        .i-sy {
            padding-top: 6px;
            width: 16%;
            font-size: 12px;
            color: #999;
            line-height: 1;
        }
        .i-tg {
            flex: 1;
            color: #fff;
            line-height: 50px;
            background: #ff9600;
        }
        .i-bk {
            flex: 1;
            color: #fff;
            line-height: 50px;
            background: #e4393c;
        }
    }
</style>
